import type { GatewayBrowserClient } from "../gateway.ts";
import type { FleetQuestionRequest } from "./fleet-question.ts";
import type { FleetTodoItem } from "./fleet-todos.ts";
import { parseFleetQuestionRequested } from "./fleet-question.ts";
import { parseFleetTodoItems } from "./fleet-todos.ts";

export async function loadFleetInteractionForSession(params: {
  client: GatewayBrowserClient;
  sessionKey: string;
}): Promise<{
  questions: FleetQuestionRequest[];
  todos: FleetTodoItem[];
}> {
  const sessionKey = params.sessionKey.trim();
  if (!sessionKey) {
    return { questions: [], todos: [] };
  }
  const [questionRes, todosRes] = await Promise.all([
    params.client.request<{ pending?: unknown[] }>("fleet.question.list", { sessionKey }),
    params.client.request<{ todos?: unknown[] }>("fleet.todos.list", { sessionKey }),
  ]);
  const questions: FleetQuestionRequest[] = [];
  for (const raw of questionRes?.pending ?? []) {
    const parsed = parseFleetQuestionRequested(raw);
    if (parsed) {
      questions.push(parsed);
    }
  }
  const todos: FleetTodoItem[] = parseFleetTodoItems(todosRes?.todos);
  return { questions, todos };
}
